var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPCollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 122,
    viewBox: "0 0 112 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 20.3333H68.625C70.028 20.3333 71.1667 19.1945 71.1667 17.7915V12.7083C71.1667 8.50426 67.7457 5.08325 63.5417 5.08325H54.524C52.7245 1.9825 49.3948 0 45.75 0C42.1053 0 38.7757 1.9825 36.9762 5.08325H27.9585C23.7545 5.08325 20.3335 8.50426 20.3335 12.7083V17.7915C20.3335 19.1947 21.472 20.3333 22.875 20.3333Z",
    fill: "url(#paint0_linear_341_2386)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.336 106.008L93.7062 104.102L93.386 102.826C95.3685 100.64 96.7715 97.849 97.356 94.9515C98.7133 94.25 99.6943 92.9182 99.8977 91.317L100.447 86.8945C100.614 85.5525 100.203 84.2003 99.3132 83.1837C99.0387 82.8685 98.7287 82.5992 98.388 82.3652L98.515 79.666L98.9775 79.2035C100.289 77.8107 102.058 74.837 99.257 70.5465C97.9353 68.5132 95.1903 66.0833 89.6903 66.0833C88.0738 66.0833 84.4188 66.0833 80.8708 68.3098C70.4093 68.6758 69.179 74.3132 69.179 78.573C69.179 79.4117 69.3265 80.9825 69.4738 82.294C69.0975 82.533 68.7468 82.8277 68.452 83.1683C67.5473 84.195 67.1303 85.5523 67.3033 86.8995L67.8523 91.322C68.0608 92.974 69.113 94.3465 70.6583 95.0227C71.2275 97.7932 72.5595 100.477 74.4148 102.607L74.0438 104.102L66.4138 106.008C60.2375 107.553 55.9167 113.084 55.9167 119.458C55.9167 120.861 57.0555 122 58.4585 122H109.292C110.695 122 111.833 120.856 111.833 119.453C111.833 113.084 107.513 107.553 101.336 106.008Z",
    fill: "url(#paint1_linear_341_2386)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4335 102.063C62.896 101.87 63.2875 101.545 63.567 101.128L64.721 99.3997C65.3157 98.5102 65.2852 97.341 64.6497 96.482C63.633 95.1045 63.013 93.5845 62.8095 91.9577L62.2605 87.515C61.9657 85.253 62.4943 82.945 63.7295 81.0082C64.0243 80.5557 64.1615 80.017 64.126 79.4782C64.1058 79.1477 64.0955 78.8377 64.0955 78.5682C64.0955 73.3832 66.022 64.5127 78.9185 63.3385C79.2338 63.308 79.5335 63.2267 79.8132 63.0895C83.9105 61.0765 87.728 61.0307 88.9835 61.0155C89.8223 61.0052 90.6153 60.5682 91.0778 59.8667C91.3523 59.45 91.4998 58.962 91.4998 58.4587V17.7917C91.4998 13.5877 88.0788 10.1667 83.8748 10.1667H78.7917C77.3887 10.1667 76.25 11.3055 76.25 12.7085V17.7917C76.25 21.9957 72.829 25.4167 68.625 25.4167H22.875C18.671 25.4167 15.25 21.9957 15.25 17.7917V12.7083C15.25 11.3052 14.1113 10.1665 12.7083 10.1665H7.625C3.421 10.1665 0 13.5875 0 17.7915V114.375C0 118.579 3.421 122 7.625 122H48.2917C49.6947 122 50.8335 120.861 50.8335 119.458C50.8335 111.854 55.388 105.027 62.4335 102.063Z",
    fill: "url(#paint2_linear_341_2386)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_2386",
    x1: 19.4774,
    y1: 21.0385,
    x2: 61.5645,
    y2: -11.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_341_2386",
    x1: 54.975,
    y1: 123.939,
    x2: 122.761,
    y2: 102.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_341_2386",
    x1: -1.54105,
    y1: 125.879,
    x2: 112.722,
    y2: 96.7631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454839,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPCollIcon);
export default __webpack_public_path__ + "static/media/p-coll-icon.dc02abd2b11f2b9954850ea1d4286ec9.svg";
export { ForwardRef as ReactComponent };